import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';

interface ConfirmCancelPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}
export const ConfirmCancelPopup: FC<ConfirmCancelPopupProps> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            Cancel Subscription
          </DialogTitle>
          <DialogDescription className="text-white text-[16px] text-center">
            Are you sure you want to cancel this subscription?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex items-center justify-center gap-10">
            <Button
              className={'w-20'}
              size={'sm'}
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              Yes, Cancel
            </Button>
            <Button
              className={'w-20'}
              size={'sm'}
              variant={'secondary'}
              onClick={() => {
                onOpenChange(false);
              }}
            >
              No, Keep It
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
